import { render, staticRenderFns } from "./image-preview-modal.vue?vue&type=template&id=42cb2d4f&scoped=true&"
import script from "./image-preview-modal.vue?vue&type=script&lang=js&"
export * from "./image-preview-modal.vue?vue&type=script&lang=js&"
import style0 from "./image-preview-modal.vue?vue&type=style&index=0&id=42cb2d4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cb2d4f",
  null
  
)

export default component.exports